import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import StorePage from './pages/StorePage';
import ProductPage from './pages/ProductPage';
import { OrderStatusPage } from './pages/OrderStatusPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { captureReferralFromUrl } from './lib/referral';

export default function App() {
  // Link rastreável de indicação (?ref=CODE) -- 12/07/2026, a pedido do
  // Thales. Captura em qualquer rota (vitrine, produto, status do pedido),
  // porque quem divulga pode mandar link direto pra um produto específico.
  const location = useLocation();
  useEffect(() => {
    const slug = location.pathname.split('/').filter(Boolean)[0];
    captureReferralFromUrl(slug);
  }, [location]);

  return (
    <ErrorBoundary>
      <Routes>
      <Route path="/:slug" element={<StorePage />} />
      <Route path="/:slug/produto/:productId" element={<ProductPage />} />
      <Route path="/:slug/pedido/:orderId" element={<OrderStatusPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
      </ErrorBoundary>
  );
}
